import { MinRelationships } from 'app/Bookings/constants'
import { emptyPatient } from 'app/Bookings/utils'
import {
  initialBookingState,
  initialBookingHelperState,
  START_BOOKING,
  SET_PATIENTS_FOR_USER,
  UPDATE_BOOKING_HELPER_FILTERS,
  SET_SELECTED_PATIENTS,
  UPDATE_BOOKING_DETAILS,
  CLEAN_BOOKING_INFO,
  SET_DROPDOWN_PATIENTS,
  RESET_PATIENT_FORM,
  UPDATE_BOOKING_HELPER_DETAILS,
  initialBookingHelperNoPersist,
  ADD_NEW_PATIENTS,
  COMPLETE_BOOKING,
  SET_B2B_DETAILS,
  SET_RP_DETAILS,
} from './constants'

export const bookingReducer = (
  state: BookingState = initialBookingState,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): BookingState => {
  const { type: actionType, payload: actionPayload } = action

  switch (actionType) {
    case UPDATE_BOOKING_DETAILS:
      return {
        ...state,
        ...actionPayload,
      }
    case SET_SELECTED_PATIENTS:
      return {
        ...state,
        selectedPatients: actionPayload,
      }
    case CLEAN_BOOKING_INFO:
      return initialBookingState
    default:
      return state
  }
}

export const bookingHelperReducer = (
  state: BookingHelperState = initialBookingHelperState,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): BookingHelperState => {
  const { type: actionType, payload: actionPayload } = action

  switch (actionType) {
    case START_BOOKING:
      return actionPayload
    case SET_PATIENTS_FOR_USER:
      return {
        ...state,
        allPatients: actionPayload,
      }
    case SET_DROPDOWN_PATIENTS:
      return {
        ...state,
        dropdownPatients: action.payload,
      }
    case UPDATE_BOOKING_HELPER_DETAILS:
      return {
        ...state,
        ...actionPayload,
      }
    case UPDATE_BOOKING_HELPER_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...actionPayload,
        },
      }
    case COMPLETE_BOOKING:
      return {
        ...state,
        isBookingComplete: actionPayload,
      }
    case SET_B2B_DETAILS:
      return {
        ...state,
        b2bUserDetails: actionPayload,
      }
    case CLEAN_BOOKING_INFO:
      const isSalesforceOrThirdPartyAgent = actionPayload as boolean
      return {
        ...initialBookingHelperState,
        b2bUserDetails: isSalesforceOrThirdPartyAgent
          ? state.b2bUserDetails
          : initialBookingHelperState.b2bUserDetails,
      }
    case SET_RP_DETAILS:
      return {
        ...state,
        responsibleParty: actionPayload,
      }
    default:
      return state
  }
}

export const bookingHelperNoPersist = (
  state: BookingHelperNoPersist = initialBookingHelperNoPersist,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): BookingHelperNoPersist => {
  const { type: actionType, payload: actionPayload } = action

  switch (actionType) {
    case ADD_NEW_PATIENTS:
      //Added relationship 'Self' to the 1st emptyPatient object (Patient 1)
      //so that relationship type of Patient 1 is by default preselected
      //as Self Patient
      const { count, hydrationData } = actionPayload
      const newPatients =
        count === 2
          ? [
              { ...hydrationData, relationship: MinRelationships.SELF },
              emptyPatient,
            ]
          : [{ ...hydrationData, relationship: MinRelationships.SELF }]
      return {
        ...state,
        newPatients: newPatients,
      }
    case RESET_PATIENT_FORM:
      return {
        ...state,
        patientFormReset: actionPayload,
      }
    case CLEAN_BOOKING_INFO:
      return initialBookingHelperNoPersist
    default:
      return state
  }
}
